import React from "react";

const BaseHeader1 = (props) => {
  return <h1 className={props.className}>{props.children}</h1>;
};

export default BaseHeader1;
